import React, { useRef, useState } from "react";
import Alerts from "../util/Alerts";
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap";
import BlkFormik from "../coms/BlkFormik";
import { Form } from "formik";
import { BlkField } from "../coms/BlkField";
import axios from "axios";
import { routes } from "./General";
import ReactTable from "react-table";
import { BlkCheckBox } from "../coms/BlkCheckBox";

export const GestorUsuario = props => {
    const getDefaultData = () => ({
        list: [],
        page: 0,
        pages: -1,
        loading: false,
        pageSize: 10,
        cdContratante: "",
        nmContratante: "",
        apContratante: "",
        cedula: "",
        nmContacto: "",
        apContacto: "",
        correo: "",
        inactivos: false,
    });

    const [data, setData] = useState(getDefaultData());
    const [listSP, setListSP] = useState([]);
    const [all, setAll] = useState(false);

    const alert = useRef();
    const form = useRef();

    const handleListSP = row => {
        if (listSP.filter(i => i.index === row.original.rnum).length > 0) {
            setListSP(listSP.filter(i => i.index !== row.original.rnum));
            setAll(false);
        } else {
            setListSP([
                ...listSP,
                {
                    index: row.original.rnum,
                    cdCliente: row.original.cdCliente,
                    correo: row.original.mail,
                    cdEjecutivo: row.original.cdEjecutivo,
                    cedula: row.original.rucCed,
                },
            ]);
            setAll(listSP.length === data.list.length);
        }
    };

    const selectAll = valor => {
        let tmp = [];
        if (valor) {
            data.list.forEach(value => {
                tmp.push({
                    index: value.rnum,
                    cdCliente: value.cdCliente,
                    correo: value.mail,
                    cdEjecutivo: value.cdEjecutivo,
                    cedula: value.rucCed,
                });
            });
        }
        setListSP(tmp);
        setAll(valor);
    };

    const handleCreaUsrWeb = submitForm => {
        const current = alert.current;
        axios
            .post(routes.api + "/usuarios-generales-crear", listSP)
            .then(res => {
                current.show_info("Activados " + res.data);
                submitForm && submitForm();
            })
            .catch(err => current.handle_error(err));
    };

    const handleInacUsrWeb = submitForm => {
        const current = alert.current;
        axios
            .post(routes.api + "/usuarios-generales-desactivar", listSP)
            .then(res => {
                current.show_info("Desactivados " + res.data);
                submitForm && submitForm();
            })
            .catch(err => current.handle_error(err));
    };

    const handleResetForm = () => {
        setListSP([]);
        setData(getDefaultData());
    };

    const onSubmit = (newValues, actions) => {
        const current = alert.current;
        setListSP([]);
        setData({ ...newValues, loading: true });
        axios
            .post(routes.api + "/usuarios-generales-gestor", { ...newValues })
            .then(res => {
                setData({ ...data, list: res.data.data, pages: res.data.totalPages, loading: false });
                //current.show_info('Búsqueda Exitosa')
                actions.setSubmitting(false);
                setListSP([]);
                setAll(false);
            })
            .catch(err => {
                actions.setSubmitting(false);
                current.handle_error(err);
            });
    };

    return (
        <div>
            <Alerts ref={alert} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">Gestor Usuarios </CardTitle>
                    <div className="container-fluid">
                        <BlkFormik
                            initialValues={data}
                            onSubmit={onSubmit}
                            ref={form}
                            enableReinitialize={true}
                            validateOnChange={false}
                        >
                            {({ values, isSubmitting, errors, handleChange, submitForm }) => (
                                <Form>
                                    <Row>
                                        <Col lg={6}>
                                            <CardTitle className="text-center" tag="h6">
                                                Contratante
                                            </CardTitle>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Nombre:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Nombre"
                                                        name="nmContratante"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Apellido:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Apellido"
                                                        name="apContratante"
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Código:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Código"
                                                        name="cdContratante"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Cédula/RUC:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Cédula"
                                                        name="cedula"
                                                    />
                                                </div>
                                            </Row>
                                        </Col>
                                        <Col lg={6}>
                                            <CardTitle className="text-center" tag="h6">
                                                Contacto
                                            </CardTitle>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Nombre:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Nombre"
                                                        name="nmContacto"
                                                    />
                                                </div>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Apellido:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Apellido"
                                                        name="apContacto"
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className={"form-group col-md-6 col-sm-12"}>
                                                    <Label>Correo:</Label>
                                                    <BlkField
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Correo"
                                                        name="correo"
                                                    />
                                                </div>

                                                <Col xs={2} className={"d-flex mt-4 align-items-center"}>
                                                    <Label className={"mr-2"}>Solo Inactivos</Label>
                                                    <BlkField
                                                        component={BlkCheckBox}
                                                        styleInput={{ marginLeft: 0, marginTop: "-10px" }}
                                                        name={"inactivos"}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12}>
                                            <Row>
                                                <div className="form-group col-lg-6 col-md-6 col-sm-12">
                                                    <Button
                                                        type={"submit"}
                                                        color="primary"
                                                        className="mb-3 mr-2"
                                                        onClick={submitForm}
                                                        disabled={isSubmitting}
                                                    >
                                                        Buscar
                                                    </Button>
                                                    <Button color="yellow" className="mb-3 " onClick={handleResetForm}>
                                                        Nueva Consulta
                                                    </Button>
                                                </div>
                                                <div className={"form-group col-lg-6 col-md-6 col-sm-12"}>
                                                    <div className="row mx-1">
                                                        {listSP.length > 0 && (
                                                            <Button
                                                                color="success"
                                                                className="mx-2"
                                                                onClick={() => handleCreaUsrWeb(submitForm)}
                                                            >
                                                                Activar consultas web
                                                            </Button>
                                                        )}
                                                        {listSP.length > 0 && (
                                                            <Button
                                                                color="danger"
                                                                onClick={() => handleInacUsrWeb(submitForm)}
                                                            >
                                                                Desactivar consultas web
                                                            </Button>
                                                        )}
                                                        <div className="form-check mx-2">
                                                            <label className="form-check-label">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    style={{ cursor: "pointer" }}
                                                                    checked={all}
                                                                    defaultChecked={all}
                                                                    onChange={e => {
                                                                        selectAll(e.target.checked);
                                                                    }}
                                                                />
                                                                <span className="form-check-sign">
                                                                    Seleccionar Todos los Usuarios
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </BlkFormik>
                        <Row>
                            <Col xs={12}>
                                <ReactTable
                                    noDataText={"No se ha encontrado información"}
                                    previousText={"Anterior"}
                                    nextText={"Siguiente"}
                                    pageText={"Página"}
                                    rowsText={"filas"}
                                    ofText={"de"}
                                    columns={[
                                        {
                                            Header: "Cód.",
                                            minResizeWidth: 50,
                                            width: 70,
                                            accessor: "cdCliente",
                                        },
                                        {
                                            Header: "Cédula/RUC Contra.",
                                            minResizeWidth: 50,

                                            width: 140,
                                            accessor: "rucCed",
                                        },
                                        {
                                            Header: "Nombres Contratante",
                                            minResizeWidth: 50,
                                            width: 140,
                                            accessor: "nmCliente",
                                        },
                                        {
                                            Header: "Apellidos Contratante",
                                            minResizeWidth: 50,
                                            width: 140,
                                            accessor: "apCliente",
                                        },
                                        {
                                            Header: "Título Contra.",
                                            minResizeWidth: 50,
                                            width: 90,
                                            accessor: "titulo",
                                        },
                                        {
                                            Header: "Nombres Contacto",
                                            minResizeWidth: 50,
                                            width: 140,
                                            accessor: "nmEjecutivo",
                                        },
                                        {
                                            Header: "Apellidos Contacto",
                                            minResizeWidth: 50,
                                            width: 140,
                                            accessor: "apEjecutivo",
                                        },
                                        {
                                            Header: "Usr. Web",
                                            minResizeWidth: 10,
                                            accessor: "activaWeb",
                                            width: 70,
                                            Cell: row => {
                                                return row.original.usuarioweb === 1 ? (
                                                    <p>
                                                        <span className={"badge badge-success"}>SI</span>
                                                    </p>
                                                ) : (
                                                    <p>
                                                        <span className={"badge badge-danger"}>NO</span>
                                                    </p>
                                                );
                                            },
                                        },
                                        {
                                            Header: "Cargo Cont.",
                                            minResizeWidth: 50,
                                            width: 110,
                                            accessor: "cargo",
                                        },
                                        {
                                            Header: "Correo",
                                            minResizeWidth: 50,
                                            width: 200,
                                            accessor: "mail",
                                        },
                                        {
                                            id: "selected",
                                            Header: "Sel.",
                                            minResizeWidth: 10,
                                            width: 50,
                                            Cell: row => {
                                                return (
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            defaultChecked={
                                                                listSP.filter(i => i.index === row.original.rnum)
                                                                    .length > 0
                                                            }
                                                        />
                                                    </div>
                                                );
                                            },
                                        },
                                    ]}
                                    getTdProps={(state, rowInfo, column) => {
                                        if (rowInfo && rowInfo.row) {
                                            return {
                                                onClick: (e, handleOriginal) => {
                                                    if (column.id === "selected") {
                                                        handleListSP(rowInfo);
                                                    }
                                                    if (handleOriginal) {
                                                        handleOriginal();
                                                    }
                                                },
                                                style: {
                                                    cursor: "pointer",
                                                    //backgroundColor: rowInfo.index === state.selected ? '#47b2a2' : 'white',
                                                    //color: rowInfo.index === state.selected ? 'white' : 'black',
                                                    height: 35,
                                                },
                                            };
                                        } else {
                                            return {};
                                        }
                                    }}
                                    manual
                                    data={data.list}
                                    pages={data.pages}
                                    loading={data.loading}
                                    onFetchData={(state, instance) => {
                                        setData({ ...data, pageSize: state.pageSize });
                                        if (data.list.length !== 0) {
                                            setData({ ...data, loading: true });
                                            axios
                                                .post(routes.api + "/usuarios-generales-gestor", {
                                                    ...data,
                                                    page: state.page,
                                                    pageSize: state.pageSize,
                                                })
                                                .then(res => {
                                                    setData({
                                                        ...data,
                                                        list: res.data.data,
                                                        pages: res.data.totalPages,
                                                        pageSize: state.pageSize,
                                                        loading: false,
                                                    });
                                                    setListSP([]);
                                                    setAll(false);
                                                })
                                                .catch(err => err);
                                        }
                                    }}
                                    sortable={false}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                ></ReactTable>
                            </Col>
                        </Row>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};
